import React from "react";
import ReactDOM from "react-dom/client"; // Pakai 'react-dom/client'
import { BrowserRouter, useLocation } from "react-router-dom";
import "antd/dist/antd.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Router from "./router";
import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEn from "./locales/en/translation.json";
import translationId from "./locales/id/translation.json";

const WhatsApp = lazy(() => import("./common/Whatsapp"));
const ScrollToTop = lazy(() => import("./common/ScrollToTop"));
const VoiceAssistant = lazy(() => import("./common/VoiceAssistant"));

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEn },
      id: { translation: translationId },
    },
    lng: localStorage.getItem("lang") || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

const Layout = () => {
  const location = useLocation();
  const isHiddenLayout = ["/dashboard", "/login"].some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      {!isHiddenLayout && <Header />}
      <Router />
      {/* <VoiceAssistant /> */}
      {/* <Suspense fallback={<div>Loading ...</div>}>
        <WhatsApp />
      </Suspense> */}
      <Suspense fallback={<div>Loading ...</div>}>
        <ScrollToTop />
      </Suspense>
      {!isHiddenLayout && <Footer />}
    </>
  );
};

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <I18nextProvider i18n={i18next}>
        <Layout />
      </I18nextProvider>
    </BrowserRouter>
  </HelmetProvider>
);

// ⬇️ Gunakan ReactDOM.createRoot() untuk React 18 ⬇️
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
